import website from "./translations/website";

import global from "./translations/global";
import app from "./translations/app";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: "de",
  missingWarn: false,
  messages: {
    en: {
      ...global.en,

      // Subpages
      app: app.en,
      website: website.en,

      // Rest
      app_name: "ChronoFox",
      id: "ID",
      document_type: "Document Type",
      current_document_no: "Document No.",
      invoice_date: "Invoice Date",
      due_date: "Due Date",
      posting_date: "Posting Date",
      location_code: "Location Code",
      correction: "Correction",
      buy_from_name: "Buy From Name",
      buy_from_name_2: "Buy From Name 2",
      buy_from_address: "Buy From Address",
      buy_from_address_2: "Buy From Address 2",
      buy_from_post_code: "Buy From Post Code",
      buy_from_country: "Buy From Country",
      buy_from_city: "Buy From City",
      created_at: "Created At",
      updated_at: "Updated At",
      currency: "Currency",
      language_code: "Language Code",
      actions: "Actions",
      line_no: "Line No.",
      line_type: "Line Type",
      item: "Item",
      create: "Create",
      search: "Search",
      difference: "Difference",
      description: "Description",
      quantity: "Quantity",
      amount_excl_vat: "Amount Excl. VAT",
      vat_percent: "VAT Percent",
      amount_incl_vat: "Amount Incl. VAT",
      debtors: "Customers",
      storage: "Storage",
      profile: "Profile",
      company_data: "Company Data",
      master_data: "Master Data",
      items: "Items",
      help: "Help",
      feedback: "Feedback",
      logout: "Logout",
      settings: "Settings",
      code: "Code",
      name: "Name",
      name2: "Name 2",
      post_code: "Post Code",
      country: "Country",
      city: "City",
      rounding_precision: "Rounding Precision",
      rounding_type: "Rounding Type",
      exchange_rate: "Exchange Rate",
      vat_rate: "VAT Rate",
      iban: "IBAN",
      swift_code: "SWIFT Code",
      add: "Add",
      apply_filters: "Apply Filters",
      all: "All",
      open: "Open",
      total: "Total",
      edit: "Edit",
      loading: "Loading...",
      object: "Object",
      save: "Save",
      me: "Me",
      priority: "Priority",
      print: "Print",
      assigned_to: "Assigned to",
      new_task: "New Task",
      status: "Status",
      home: "Home",
      no_actions: "No actions available.",
      currencies: "Currencies",
      cancel: "Cancel",
      document_text_area: "Document Text Area",
      close: "Close",
      phone: "Phone",
      email: "Email",
      general: "General",
      header_text_area: "Header Text Area",
      footer_text_area: "Footer Text Area",
      additional_information: "Additional Information",
      comment: "Comment",
      homepage: "Homepage",
      address: "Address",
      language: "Language",
      bankname: "Name of bank",
      apply: "Apply",
      is_active: "Active",
      administration: "Administration",
      business_partners: "Business Partners",
      finances: "Finances",
      vat_rates: "Vat Rates",
      users: "Users",
      user_management: "User Management",
      bank_details: "Bank Details",
      tax: "Tax",
      contact: "Contact",
      other_informations: "Other Informations",
      company: "Company",
      project_management: "Project Management",
      project: "Project",
      projects: "Projects",
      timelog: "Timelog",
      timelogs: "Timelogs",
      tasks: "Tasks",
      digital_clock: "Digital Clock",
      debtor: "Customer",
      start: "Start",
      stop: "Stop",
      your_profile: "Your Profile",
      activities: "Activities",
      dashboard: "Dashboard",
      choose_your_plan: "Choose your plan",
      select_the_plan_that_best_suits_your_needs:
        "Select the plan that best suits your needs",
      free: "Free",
      plus: "Plus",
      plus_t14: "Plus (14 days trial)",
      premium: "Premium",
      premium_t14: "Premium (14 days trial)",
      get_started: "Get Started",
      fourteen_days_free_trial: "14 days free trial",
      per_month: "per month",
      pdf_report: "PDF Report",
      manual_creation_of_timelogs: "Manual creation of timelogs",
      no_watermarks_on_reports: "No watermarks on reports",
      customer_management: "Customer management",
      dont_have_an_account: "Don't have an account?",
      sign_up: "Sign up",
      budget: "Budget",
      create_edit_debtor: "Create/ Edit Customer",
      address2: "Address 2",
      currency_code: "Currency Code",
      add_activity: "Add Activity",
      edit_activity: "Edit Activity",
      hourly_rate: "Hourly Rate",
      yes: "Yes",
      no: "No",
      search_or_select_dot: "Search or select...",
      no_data: "No data available",
      first_name: "First Name",
      last_name: "Last Name",
      is_staff: "Staff (Yes/No)",
      date_joined: "Date Joined",
      language_preference: "Language Preference",
      add_currency: "Add Currency",
      edit_currency: "Edit Currency",
      start_time: "Start Time",
      end_time: "End Time",
      pause_subtract: "Pause Subtract",
      billable: "Billable (Yes/No)",
      not_billable: "Not Billable (Yes/No)",
      bill_to_debtor: "Bill to Customer",
      is_billed: "Is Billed (Yes/No)",
      is_standalone: "Is Standalone (Yes/No)",
      activity: "Activity",
      filters: "Filters",
      reset_filters: "Reset Filters",
      billed: "Billed",
      not_billed: "Not Billed",
      print_to_pdf: "Print to PDF",
      create_edit_timelog: "Create/ Edit Timelog",
      amount_of_timelogs: "Amount of Timelogs",
      revenue: "Revenue",
      unbilled_timelogs: "Open Timelogs",
      amount_of_debtors: "Amount of Customers",
      active_projects: "Active Projects",
      amount: "Amount",
      username: "Email",
      password: "Password",
      login: "Login",
      amount_earned: "Earned Amount",
      amount_of_unbilled_billable_timelogs_per_activity:
        "Open Timelogs per activity",
      billed_revenue: "Billed Revenue",
      amount_billed: "Billed Amount",
      amount_unbilled: "Unbilled Amount",
      features: "Features",
      pricing: "Pricing",
      sign_up_now: "Sign up now",
      imprint: "Imprint",
      privacy_policy: "Privacy Policy",
      track_your_time_effortlessly: "Track Your Time Effortlessly",
      simplify_time_tracking_and_reporting_for_your_freelance_work:
        "ChronoFox is a powerful time tracking and project management software for freelancers and businesses. Try ChronoFox out for free!",
      time_tracking_illustration: "Time tracking illustration",
      how_it_works: "How It Works",
      start_tracking_your_time_today: "Start Tracking Your Time Today",
      get_accurate_reports_and_make_billing_easier_than_ever:
        "Get accurate reports and make billing easier than ever.",
      easy_time_tracking: "Easy Time Tracking",
      start_and_stop_your_timer_with_one_click:
        "Start and stop your timer with one click.",
      detailed_reports: "Detailed Reports",
      generate_comprehensive_timelogs_for_accurate_billing:
        "Generate comprehensive timelogs for accurate billing.",
      export_to_pdf_or_csv: "Export to PDF or CSV",
      easily_export_your_time_reports_for_clients:
        "Easily export your time reports for clients.",
      step_1_sign_up: "Step 1: Sign Up",
      create_an_account_in_a_few_easy_steps:
        "Create an account in a few easy steps.",
      step_3_track_time: "Step 3: Track Time",
      start_your_timer_whenever_you_start_working:
        "Start your timer whenever you start working.",
      step_2_setup_company: "Step 2: Setup Company",
      setup_your_company_and_add_customers_and_projects:
        "Setup your company and add customers and projects.",
      register: "Register",
      timelogs_in_project: "Timelogs in Project",
      pause_clock: "Pause Clock",
      reset_password: "Reset Password",
      german: "German (DE)",
      english: "English (EN)",
      start_time_after: "Start Time After",
      end_time_before: "End Time Before",
      export_to_csv: "Export to CSV",
      billing_periods: "Billing Periods",
      user_subscription: "User-Subscriptions",
      billing: "Billing",
      billing_period: "Billing Period",
      subscription_type: "Subscription Type",
      start_date: "Start Date",
      end_date: "End Date",
      billing_status: "Billing Status",
      invoiced_amount: "Invoiced Amount",
      invoice_number: "Invoice Number",
      was_cancelled: "Was cancelled",
      user: "User",
      submit: "Submit",
      tell_us_about_your_company: "Tell us about your company",
      what_is_your_company_name: "What is your company name?",
      how_big_is_your_company: "How big is your company?",
      next: "Next",
      price: "Price",
      price_per_month: "Price per month",
      price_slash_month: "Price/ Month",
      plan: "plan",
      your_selected_plan: "Your selected plan",
      back: "Back",
      timelogs_for_debtor: "Timelogs for Customer",
      time_tracking: "Time Tracking",
      freelancer: "Freelancer",
      reporting: "Reporting",
      filter: "Filter",
      create_your_user: "Create your user",
      unbilled: "Unbilled",
      i_know_that_based_on_my_subscription_the_costs_will_be_charged_for_the_new_user:
        "I know that based on my subscription the costs will be charged for the new user",
      i_know_that_the_change_will_be_valid_from_the_next_billing_period:
        "I know that the change will be valid from the next billing period",
      startpage_detailedfeatures_customer_management:
        "Easily manage all your clients in one place with ChronoFox. Add new customers with key details like name, address, and email, and keep track of interactions and billing efficiently. Perfect for self-employed professionals and companies looking to streamline client data.",
      startpage_detailedfeatures_digital_clock:
        "Track your work time with ChronoFox's digital timer. Start and stop the timer with one click to accurately track work time and boost productivity.",
      startpage_detailedfeatures_projects:
        "rganize your projects with ease. With ChronoFox, you can create, assign, and track projects and tasks, including hourly rates and work packages, for accurate time tracking and billing. Ideal for freelancers and teams working on multiple projects.",
      view_detailed_pricing: "View detailed pricing and features",
      amount_of_unbilled_billable_timelogs_per_debtor:
        "Open timelogs per debtor",
      time_tracking_variant: "Time tracking variant",
      minute: "Minute",
      quarter_hour: "Quarter Hour",
      half_hour: "Half Hour",
      hour: "Hour",
      statistics: "Statistics",
      unbilled_revenue: "Unbilled Revenue",
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
      create_timelog: "Create Timelog",
      setup: "Setup",
      go_to_app: "Go to App",
      create_project: "Create Project",
      select_date_and_time: "Select date and time",
      add_timelog: "Add Timelog",
      bill_all_entries: "Bill all Entries",
      please_confirm_that_this_amount_of_timelogs_will_be_billed:
        "Please confirm that this amount of timelogs will be billed",
      timelog_count: "Amount of Timelogs",
      hourly_rate_rules: "Hourly Rate Rules",
      add_hourly_rate_rules: "Add Hourly Rate Rules",
      edit_hourly_rate_rules: "Edit Hourly Rate Rules",
      order: "Order",
      earned_amount: "Earned Amount",
      please_enter: "Please enter",
      please_select: "Please select",
      user_info: "User Info",
      company_info: "Company Info",
      confirm_plan: "Confirm Plan",
      standard_time_tracking_variant: "Standard Time Tracking Variant",
      time_log_billing: "Billing of Timelogs",
      time_log_csv_export: "CSV Export of Timelogs",
      no_watermarks_on_pdf_reports: "No Watermarks on PDF Reports",
      manual_creation_of_time_logs: "Manual creation of Timelogs",
      pause: "Pause",
      auto_renewal: "Auto Renewal",
      will_be_auto_renewed: "Will be auto-renewed",
      valid_to: "Valid to",
      your_company_subscription: "Your Company Subscription",
      cancel_subscription: "Cancel Subscription",
      change_subscription: "Change Subscription",
      period_duration: "Subscription Duration",
      monthly: "Monthly",
      yearly: "Yearly",
      cancelled: "Cancelled",
      hourly_rate_rules_info:
        "With hourly rate rules, you can overwrite the default hourly rate for your activities. This allows you to set an individual hourly rate for each activity based on customers, projects and a sequence.",
      confirm_delete: "Confirm deletion",
      customers_and_projects: "Customers and Projects",
      manage_your_timelogs_for_customers_and_projects:
        "Manage your timelogs for customers and projects",
      dataimport: "Data import",
      view_all_features: "View all features",
      i_accept_the_terms_and_conditions: "I accept the terms and conditions",
      i_accept_the_privacy_policy: "I accept the privacy policy",
      select_plan: "Select your plan",
      per_day: "Per Day",
      per_timelog: "Per Timelog",
      hours: "Hours",
      settings_and_profile: "Settings & Profile",
      errors: "Erros",
      resume: "Resume",
      average_hourly_rate: "Avg. Hourly Rate",
      total_hours: "Total Hours",
      total_timelogs: "Timelogs",
      total_billed_timelogs: "Billed Timelogs",
      average_hourly_rate_only_billable: "Avg. Hourly Rate (only billable)",
      total_amount: "Total Amount",
      total_billable_timelogs: "Billable Timelogs",
      total_unbilled_timelogs: "Unbilled Timelogs",
      per_hour: "Per Hour",
      per_amount: "Per Amount",
      percentage_of_activity_based_on_revenue: "Activities based on revenue",
      percentage_of_debtors_based_on_revenue: "Debtors based on revenue",
      calender: "Calender",
      only_mine: "Only mine",
      filter_by_user: "Filter by user",
      non_billable: "Non billable",
      filter_by_billable: "Filter by billability",
      company_image: "Company Image",
      filter_columns: "Filter columns",
      report: "Report",
      type: "Type",
      use_custom_columns: "Use custom columns",
      select_columns_to_show: "Select columns to show",
      horizontal: "Horizontal",
      vertical: "Vertical",
      company_size: "Company Size",
      for_starters: "For Starters",
      for_freelancers: "For Freelancers",
      for_businesses: "For Businesses",
      per_user: "per user",
      show_all_plans: "Show all plans",
      trustcenter: "Trustcenter",
      detailed_overview: "Detailed Overview",
      feature: "Feature",
      an_error_occurred: "An error occurred",
      no_active_account_found_with_the_given_credentials:
        "No active account found with the given credentials",
      registration_failed: "Registration failed",
      user_already_exists: "User already exists",
      team_member_count: "Team Member Count",
      team: "Team",
      teams: "Teams",
      create_team: "Create Team",
      edit_team: "Edit Team",
      create_edit_team: "Create/ Edit Team",
      category: "Category",
      used_by: "Used by",
      learn_more: "Learn more",
      months: "Months",
      minimum_duration: "Minimum Duration",
      pdf_reports: "PDF Reports",
      zzgl: "plus",
      vat: "VAT",
      date: "Date",
      time: "Time",
      digital_clock_not_available: "Digital Clock not available",
      border_layout: "Border Layout",
      minimal: "Minimal",
      internal: "Internal",
      single_top_line: "Single Top Line",
      horizontal_lines: "Horizontal Lines",
      none: "None",
      no_horizontal_lines: "No Horizontal Lines",
      no_clock_running: "No clock running",
      revenue_this_month: "Revenue this month",
      unbilled_billable_revenue: "Revenue to bill",
      go_to_clock: "Go to clock",
      compare_plans: "Compare Plans",
      administrator: "Administrator",
      current_subscription: "Current Subscription",
      future_subscription: "Future Subscription",
      next_subscription_type: "Next Subscription Type",
      worktime: "Worktime",
      projecttime: "Projecttime",
      overview: "Overview",
      vacation: "Vacation",
      add_user: "Add User",
      edit_user: "Edit User",
      current_week: "Cur. Week",
      current_month: "Cur. Month",
      current_quarter: "Cur. Quarter",
      current_year: "Cur. Year",
      past_7_days: "7 Days",
      past_30_days: "30 Days",
      past_90_days: "90 Days",
      past_365_days: "365 Days",
      agb: "General Terms and Conditions (AGB)",
      duration_in_days: "Duration in days",
      duration_in_months: "Duration in months",
      organization: "Organisation",
      revenue_over_time: "Revenue over time",
      activity_and_debtor_insights: "Activity and debtor insights",
      time_selection: "Time selection",
      last_365_days: "365 days",
      last_30_days: "30 days",
      last_7_days: "7 days",
      upgrade_subscription: "Upgrade Subscription",
      confirm_subscription_cancelation:
        "Please confirm that you want to cancel your subscription. Your data will be deleted after the end of the current billing period.",
      edit_profile: "Edit Profile",
      go_to_running_clock: "Go to running clock",
      delete_timelog: "Delete Timelog",
      edit_timelog: "Edit Timelog",
      bill_timelog: "Bill Timelog",
      this_is_the_default_time_tracking_variant_you_can_change_it_for_each_debtor:
        "This is the default time tracking variant. You can change it for each debtor.",
      close_project: "Close Project",
    },
    de: {
      ...global.de,

      // Subpages
      website: website.de,
      app: app.de,

      // Rest
      app_name: "ChronoFox",
      id: "ID",
      document_type: "Dokumententyp",
      current_document_no: "Dokumentennummer",
      invoice_date: "Rechnungsdatum",
      due_date: "Fälligkeitsdatum",
      posting_date: "Buchungsdatum",
      location_code: "Standortcode",
      correction: "Korrektur",
      buy_from_name: "Kauf von Name",
      buy_from_name_2: "Kauf von Name 2",
      buy_from_address: "Kauf von Adresse",
      buy_from_address_2: "Adresszusatz",
      buy_from_post_code: "Kauf von Postleitzahl",
      buy_from_country: "Kauf von Land",
      buy_from_city: "Kauf von Stadt",
      created_at: "Erstellt am",
      updated_at: "Aktualisiert am",
      currency: "Währung",
      language_code: "Sprachcode",
      actions: "Aktionen",
      line_no: "Positionsnummer",
      line_type: "Positionstyp",
      item: "Artikel",
      description: "Beschreibung",
      quantity: "Menge",
      amount_excl_vat: "Betrag exkl. MwSt.",
      vat_percent: "MwSt.-Prozentsatz",
      amount_incl_vat: "Betrag inkl. MwSt.",
      difference: "Differenz",
      debtors: "Kunden",
      storage: "Lager",
      profile: "Profil",
      company_data: "Firmendaten",
      master_data: "Stammdaten",
      items: "Artikel",
      help: "Hilfe",
      feedback: "Feedback",
      logout: "Abmelden",
      settings: "Einstellungen",
      code: "Code",
      name: "Name",
      name2: "Name 2",
      post_code: "Postleitzahl",
      country: "Land",
      city: "Stadt",
      rounding_precision: "Rundungsgenauigkeit",
      rounding_type: "Rundungstyp",
      exchange_rate: "Wechselkurs",
      vat_rate: "MwSt. Satz",
      iban: "IBAN",
      swift_code: "SWIFT Code",
      add: "Hinzufügen",
      apply_filters: "Filter anwenden",
      all: "Alle",
      open: "Offen",
      total: "Gesamt",
      edit: "Bearbeiten",
      loading: "Laden...",
      object: "Objekt",
      save: "Speichern",
      me: "Mich",
      priority: "Priorität",
      print: "Drucken",
      assigned_to: "Zugewiesen an",
      new_task: "Neue Aufgabe",
      status: "Status",
      home: "Startseite",
      no_actions: "Keine Aktionen verfügbar.",
      currencies: "Währungen",
      cancel: "Abbrechen",
      document_text_area: "Dokument Textbereich",
      close: "Schließen",
      phone: "Telefon",
      email: "E-Mail",
      general: "Allgemein",
      header_text_area: "Kopfzeilentext",
      footer_text_area: "Fußzeilentext",
      additional_information: "Zusatzinformationen",
      comment: "Kommentar",
      homepage: "Webseite",
      address: "Adresse",
      language: "Sprache",
      bankname: "Bankname",
      apply: "Anwenden",
      create: "Erstellen",
      search: "Suchen",
      is_active: "Aktiv",
      administration: "Verwaltung",
      business_partners: "Geschäftspartner",
      finances: "Finanzen",
      vat_rates: "Steuersätze",
      users: "Benutzer",
      user_management: "Benutzerverwaltung",
      bank_details: "Bankdetails",
      tax: "Steuer",
      contact: "Kontakt",
      other_informations: "Andere Informationen",
      company: "Unternehmen",
      project_management: "Projektmanagement",
      project: "Projekt",
      projects: "Projekte",
      timelog: "Zeiteintrag",
      timelogs: "Zeiteinträge",
      tasks: "Aufgaben",
      digital_clock: "Digitale Uhr",
      debtor: "Kunde",
      start: "Start",
      stop: "Stop",
      your_profile: "Dein Profil",
      activities: "Tätigkeiten",
      dashboard: "Dashboard",
      choose_your_plan: "Wählen Sie Ihren Plan",
      select_the_plan_that_best_suits_your_needs:
        "Wählen Sie den Plan, der Ihren Anforderungen am besten entspricht",
      free: "Kostenlos",
      plus: "Plus",
      plus_t14: "Plus (14 Tage Test)",
      premium: "Premium",
      premium_t14: "Premium (14 Tage Test)",
      get_started: "Loslegen",
      fourteen_days_free_trial: "14 Tage kostenlos testen",
      per_month: "pro Monat",
      pdf_report: "PDF Bericht",
      manual_creation_of_timelogs: "Manuelle Erstellung von Zeiterfassungen",
      no_watermarks_on_reports: "Keine Wasserzeichen auf Berichten",
      customer_management: "Kundenmanagement",
      dont_have_an_account: "Sie haben noch kein Konto?",
      sign_up: "Registrieren",
      budget: "Budget",
      create_edit_debtor: "Kunden erstellen/ bearbeiten",
      address2: "Addresszusatz",
      currency_code: "Währungscode",
      add_activity: "Aktivität hinzufügen",
      edit_activity: "Aktivität bearbeiten",
      hourly_rate: "Stundensatz",
      yes: "Ja",
      no: "Nein",
      search_or_select_dot: "Suchen oder auswählen...",
      no_data: "Keine Daten verfügbar",
      first_name: "Vorname",
      last_name: "Nachname",
      is_staff: "Mitarbeiter (Ja/Nein)",
      date_joined: "Beitrittsdatum",
      language_preference: "Spracheinstellung",
      add_currency: "Währung hinzufügen",
      edit_currency: "Währung bearbeiten",
      start_time: "Startzeit",
      end_time: "Endzeit",
      pause_subtract: "Pausenabzug",
      billable: "Abrechenbar",
      is_billable: "Abrechenbar (Ja/Nein)",
      not_billable: "Nicht abrechenbar",
      is_not_billable: "Nicht abrechenbar (Ja/Nein)",
      bill_to_debtor: "Abzurechnender Kunde",
      is_billed: "Abgerechnet (Ja/Nein)",
      is_standalone: "Eigenständig (Ja/Nein)",
      activity: "Aktivität",
      filters: "Filter",
      reset_filters: "Filter zurücksetzen",
      billed: "Abgerechnet",
      not_billed: "Nicht abgerechnet",
      print_to_pdf: "Als PDF drucken",
      create_edit_timelog: "Zeiteintrag erstellen/ bearbeiten",
      amount_of_timelogs: "Anzahl der Zeiteinträge",
      revenue: "Umsatz",
      unbilled_timelogs: "Offene Zeiteinträge",
      amount_of_debtors: "Anzahl der Kunden",
      active_projects: "Aktive Projekte",
      amount: "Menge",
      username: "E-Mail",
      password: "Passwort",
      login: "Login",
      amount_earned: "Verdiente Summe",
      amount_of_unbilled_billable_timelogs_per_activity:
        "Offene Zeiteinträge pro Aktivität",
      billed_revenue: "Abgerechneter Umsatz",
      amount_billed: "Abgerechnete Menge",
      amount_unbilled: "Nicht abgerechnete Menge",
      features: "Funktionen",
      pricing: "Preise",
      sign_up_now: "Jetzt anmelden",
      imprint: "Impressum",
      privacy_policy: "Datenschutzerklärung",
      track_your_time_effortlessly: "Verfolge Deine Zeit Mühelos",
      simplify_time_tracking_and_reporting_for_your_freelance_work:
        "ChronoFox ist eine leistungsstarke Zeiterfassungs- und Projektmanagement-Software für Freelancer und Unternehmen. Probier ChronoFox kostenlos aus!",
      time_tracking_illustration: "Zeiterfassungsillustration",
      how_it_works: "Wie es funktioniert",
      start_tracking_your_time_today:
        "Beginne noch heute, deine Zeit zu erfassen",
      get_accurate_reports_and_make_billing_easier_than_ever:
        "Erhalte genaue Berichte und erleichtere die Abrechnung wie nie zuvor.",
      easy_time_tracking: "Einfache Zeiterfassung",
      start_and_stop_your_timer_with_one_click:
        "Starte und stoppe deinen Timer mit einem Klick.",
      detailed_reports: "Detaillierte Berichte",
      generate_comprehensive_timelogs_for_accurate_billing:
        "Erstelle umfassende Zeitprotokolle für eine genaue Abrechnung.",
      export_to_pdf_or_csv: "In PDF oder CSV exportieren",
      easily_export_your_time_reports_for_clients:
        "Exportiere deine Zeitberichte einfach für Kunden.",
      step_1_sign_up: "Schritt 1: Registriere dich",
      create_an_account_in_a_few_easy_steps:
        "Erstelle ein Konto in ein paar einfachen Schritten.",
      step_3_track_time: "Schritt 3: Zeit erfassen",
      start_your_timer_whenever_you_start_working:
        "Starte deinen Timer, wann immer du mit der Arbeit beginnst.",
      step_2_setup_company: "Step 2: Setup Company",
      setup_your_company_and_add_customers_and_projects:
        "Richte dein Unternehmen ein und füge Kunden und Projekte hinzu.",
      register: "Registrieren",
      timelogs_in_project: "Zeiteinträge im Projekt",
      pause_clock: "Uhr pausieren",
      reset_password: "Passwort zurücksetzen",
      german: "Deutsch (DE)",
      english: "Englisch (EN)",
      start_time_after: "Startzeit nach",
      end_time_before: "Endzeit vor",
      export_to_csv: "Als CSV exportieren",
      billing_periods: "Abrechnungen",
      user_subscription: "Benutzer-Abos",
      billing: "Abrechnung",
      billing_period: "Abrechnungszeitraum",
      subscription_type: "Abo-Typ",
      start_date: "Startdatum",
      end_date: "Enddatum",
      billing_status: "Abrechnungsstatus",
      invoiced_amount: "In Rechnung gestellter Betrag",
      invoice_number: "Rechnungsnummer",
      was_cancelled: "Wurde beendet",
      user: "Benutzer",
      submit: "Absenden",
      tell_us_about_your_company: "Erzählen Sie uns von Ihrem Unternehmen",
      what_is_your_company_name: "Wie heißt Ihr Unternehmen?",
      how_big_is_your_company: "Wie groß ist Ihr Unternehmen?",
      next: "Weiter",
      price: "Preis",
      price_per_month: "Preis pro Monat",
      price_slash_month: "Preis/ Monat",
      plan: "Abo",
      your_selected_plan: "Dein ausgewähltes Abo",
      back: "Zurück",
      timelogs_for_debtor: "Zeiteinträge für den Kunden",
      time_tracking: "Zeiterfassung",
      freelancer: "Freelancer",
      reporting: "Berichterstattung",
      filter: "Filter",
      create_your_user: "Erstelle deinen Benutzer",
      unbilled: "Nicht abgerechnet",
      i_know_that_based_on_my_subscription_the_costs_will_be_charged_for_the_new_user:
        "Ich weiß, dass basierend auf meinem Abonnement die Kosten für den neuen Benutzer berechnet werden",
      i_know_that_the_change_will_be_valid_from_the_next_billing_period:
        "Ich weiß, dass die Änderung ab dem nächsten Abrechnungszeitraum gültig ist",
      startpage_detailedfeatures_customer_management:
        "Verwalten Sie alle Ihre Kunden einfach an einem Ort mit ChronoFox. Fügen Sie neue Kunden mit wichtigen Details wie Name, Adresse und E-Mail hinzu und behalten Sie Interaktionen und Abrechnungen effizient im Blick. Ideal für Selbständige und Unternehmen, die Kundendaten optimieren möchten.",
      startpage_detailedfeatures_digital_clock:
        "Erfassen Sie Ihre Arbeitszeit mit dem digitalen Timer von ChronoFox. Starten und stoppen Sie den Timer mit einem Klick, um die Arbeitszeit genau zu erfassen und die Produktivität zu steigern.",
      startpage_detailedfeatures_projects:
        "Organisieren Sie Ihre Projekte mühelos. Mit ChronoFox können Sie Projekte erstellen, einschließlich Stundenlöhnen und Arbeitspaketen, für eine genaue Zeiterfassung und Abrechnung. Ideal für Freelancer und Teams, die an mehreren Projekten arbeiten.",
      view_detailed_pricing: "Detaillierte Preise und Funktionen anzeigen",
      amount_of_unbilled_billable_timelogs_per_debtor:
        "Offene Zeiteinträge pro Kunde",
      time_tracking_variant: "Zeiterfassungsvariante",
      minute: "Minute",
      quarter_hour: "Viertelstunde",
      half_hour: "Halbe Stunde",
      hour: "Stunde",
      statistics: "Statistiken",
      unbilled_revenue: "Nicht abgerechneter Umsatz",
      january: "Januar",
      february: "Februar",
      march: "März",
      april: "April",
      may: "Mai",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "Dezember",
      create_timelog: "Zeiteintrag erstellen",
      setup: "Einrichtung",
      go_to_app: "Zur App",
      create_project: "Projekt erstellen",
      select_date_and_time: "Datum und Uhrzeit auswählen",
      add_timelog: "Timelog hinzufügen",
      bill_all_entries: "Alle Einträge abrechnen",
      please_confirm_that_this_amount_of_timelogs_will_be_billed:
        "Bitte bestätige, dass diese Anzahl von Timelogs abgerechnet wird",
      timelog_count: "Anzahl Zeiteinträge",
      hourly_rate_rules: "Stundensatzregeln",
      add_hourly_rate_rules: "Stundensatzregeln hinzufügen",
      edit_hourly_rate_rules: "Stundensatzregeln bearbeiten",
      order: "Reihenfolge",
      earned_amount: "Verdienter Betrag",
      please_enter: "Bitte eingeben",
      please_select: "Bitte auswählen",
      user_info: "Benutzerinformationen",
      company_info: "Firmeninformationen",
      confirm_plan: "Abo bestätigen",
      standard_time_tracking_variant: "Standard Zeiterfassungsvariante",
      time_log_billing: "Abrechnung von Zeiteinträgen",
      time_log_csv_export: "CSV-Export von Zeiteinträgen",
      no_watermarks_on_pdf_reports: "Keine Wasserzeichen auf PDF-Berichten",
      manual_creation_of_time_logs: "Manuelle Erstellung von Zeiteinträgen",
      pause: "Pause",
      auto_renewal: "Automatische Verlängerung",
      will_be_auto_renewed: "Wird automatisch verlängert",
      valid_to: "Gültig bis",
      your_company_subscription: "Ihr Unternehmensabo",
      cancel_subscription: "Abo kündigen",
      change_subscription: "Abo ändern",
      period_duration: "Abodauer",
      monthly: "Monatlich",
      yearly: "Jährlich",
      cancelled: "Gekündigt",
      hourly_rate_rules_info:
        "Mit Stundensatzregeln kannst du den standardmäßig hinterlegten Stundensatz für deine Aktivitäten überschreiben. So kannst du für jede Aktivität einen individuellen Stundensatz basierend auf Kunden, Projekten und einer Reihenfolge festlegen.",
      confirm_delete: "Löschen bestätigen",
      customers_and_projects: "Kunden und Projekte",
      manage_your_timelogs_for_customers_and_projects:
        "Verwalten Sie Ihre Zeiteinträge für Kunden und Projekte",
      dataimport: "Datenimport",
      view_all_features: "Alle Features anschauen",
      i_accept_the_terms_and_conditions: "Ich akzeptiere die AGB",
      i_accept_the_privacy_policy: "Ich akzeptiere die Datenschutzbestimmungen",
      select_plan: "Wähle deinen Plan aus",
      per_day: "Pro Tag",
      per_timelog: "Pro Zeiteintrag",
      hours: "Stunden",
      settings_and_profile: "Einstellungen & Profil",
      errors: "Fehler",
      resume: "Fortsetzen",
      average_hourly_rate: "Ø Stundensatz",
      total_hours: "Gesamtstunden",
      total_timelogs: "Zeiteinträge",
      total_billed_timelogs: "Abgerechnete Zeiteinträge",
      average_hourly_rate_only_billable: "Ø Abrechenbarer Stundensatz",
      total_amount: "Gesamtbetrag",
      total_billable_timelogs: "Abrechenbare Zeiteinträge",
      total_unbilled_timelogs: "Nicht abgerechnete Zeiteinträge",
      per_hour: "Pro Stunde",
      per_amount: "Pro Betrag",
      percentage_of_activity_based_on_revenue: "Aktivitäten nach Umsatz",
      percentage_of_debtors_based_on_revenue: "Kunden nach Umsatz",
      calender: "Kalender",
      only_mine: "Nur meine",
      filter_by_user: "Benutzerfilter",
      non_billable: "Nicht abrechenbar",
      filter_by_billable: "Filter nach Abrechenbarkeit",
      company_image: "Unternehmenslogo",
      filter_columns: "Spalten filtern",
      report: "Bericht",
      type: "Typ",
      use_custom_columns: "Benutzerdefinierte Spalten verwenden",
      select_columns_to_show: "Spalten zum Anzeigen auswählen",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      company_size: "Unternehmensgröße",
      for_starters: "Für Einsteiger",
      for_freelancers: "Für Freelancer",
      for_businesses: "Für Unternehmen",
      per_user: "pro Benutzer",
      show_all_plans: "Alle Pläne anzeigen",
      trustcenter: "Trustcenter",
      detailed_overview: "Detaillierte Übersicht",
      feature: "Feature",
      an_error_occurred: "Ein Fehler ist aufgetreten",
      no_active_account_found_with_the_given_credentials:
        "Kein aktives Konto mit den angegebenen Anmeldeinformationen gefunden",
      registration_failed: "Registrierung fehlgeschlagen",
      user_already_exists: "Benutzer existiert bereits",
      team_member_count: "Anzahl der Teammitglieder",
      team: "Team",
      teams: "Teams",
      create_team: "Team erstellen",
      edit_team: "Team bearbeiten",
      create_edit_team: "Team erstellen/ bearbeiten",
      category: "Kategorie",
      used_by: "Geeignet für",
      learn_more: "Mehr erfahren",
      months: "Monate",
      minimum_duration: "Mindestdauer",
      pdf_reports: "PDF Berichte",
      zzgl: "zzgl.",
      vat: "MwSt.",
      date: "Datum",
      time: "Zeit",
      digital_clock_not_available: "Digitale Uhr nicht verfügbar",
      border_layout: "Rahmenlayout",
      minimal: "Minimal",
      internal: "Intern",
      single_top_line: "Einzelne obere Linie",
      horizontal_lines: "Horizontale Linien",
      none: "Keine",
      no_horizontal_lines: "Keine horizontalen Linien",
      no_clock_running: "Keine Stoppuhr läuft",
      revenue_this_month: "Umsatz in diesem Monat",
      unbilled_billable_revenue: "Abzurechender Umsatz",
      go_to_clock: "Zur Uhr",
      compare_plans: "Pläne vergleichen",
      administrator: "Administrator",
      current_subscription: "Aktueller Plan",
      future_subscription: "Zukünftiger Plan",
      next_subscription_type: "Nächster Abo-Typ",
      worktime: "Arbeitszeit",
      projecttime: "Projektzeit",
      overview: "Übersicht",
      vacation: "Urlaub",
      add_user: "Benutzer anlegen",
      edit_user: "Benutzer bearbeiten",
      current_week: "Akt. Woche",
      current_month: "Akt. Monat",
      current_quarter: "Akt. Quartal",
      current_year: "Akt. Jahr",
      past_7_days: "7 Tage",
      past_30_days: "30 Tage",
      past_90_days: "90 Tage",
      past_365_days: "365 Tage",
      agb: "Allgemeine Geschäftsbedingungen (AGB)",
      duration_in_days: "Dauer in Tagen",
      duration_in_months: "Dauer in Monaten",
      organization: "Organisation",
      revenue_over_time: "Umsatz über die Zeit",
      activity_and_debtor_insights: "Aktivitäts- und Kunden-Einblicke",
      time_selection: "Zeitauswahl",
      last_365_days: "365 Tage",
      last_30_days: "30 Tage",
      last_7_days: "7 Tage",
      upgrade_subscription: "Abo upgraden",
      confirm_subscription_cancelation:
        "Bitte bestätige, dass du dein Abo kündigen möchtest. Deine Daten werden nach Ablauf des Abos gelöscht.",
      edit_profile: "Profil bearbeiten",
      go_to_running_clock: "Zur laufenden Uhr",
      delete_timelog: "Zeiteintrag löschen",
      edit_timelog: "Zeiteintrag bearbeiten",
      bill_timelog: "Zeiteintrag abrechnen",
      this_is_the_default_time_tracking_variant_you_can_change_it_for_each_debtor:
        "Dies ist die Standard-Zeiterfassungsvariante, die Sie für jeden Kunden ändern können.",
      close_project: "Projekt abschließen",
    },
  },
}));
